export enum BookingStatus {
  REQUEST = 'Request',
  QUOTATION = 'Quotation Sent',
  CUSTOMER_ACCEPTED = 'Customer Accepted',
  CUSTOMER_REJECTED = 'Rejected',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled'
}
